import { isWeb } from 'universal-env';
var width;
if (isWeb) {
  var screenWidth = window.screen.width;
  width = screenWidth ? screenWidth : document.documentElement.clientWidth / 750 * screenWidth;
}
var scalingWidth = [110, 140, 150, 170, 220, 230, 240, 290, 300, 360, 450, 570, 580, 620, 790];
var visualStandard = 750;
function find(width) {
  var min = 1000;
  var result = width;
  var fKey = 0;
  var isMatchValue = false;
  for (var i = 0; i < scalingWidth.length; i++) {
    var num = scalingWidth[i];
    var abs = Math.abs(num - width);
    if (abs === 0) {
      result = num;
      fKey = i;
      isMatchValue = true;
    }
    if (min > abs && !isMatchValue) {
      min = abs;
      result = num;
      fKey = i;
    }
  }
  if (width > result && scalingWidth[fKey + 1]) {
    result = scalingWidth[fKey + 1];
  }
  if (scalingWidth.indexOf(result) > -1) {
    return result;
  }
  return false;
}
export default function (sWidth, isOSSImg) {
  var xWidth = 0;
  var scaling = 1;
  if (typeof sWidth === 'string') {
    xWidth = parseFloat(sWidth);
    if (sWidth.indexOf('rpx') > -1) {
      if (width) {
        scaling = visualStandard / width;
      }
    }
  } else {
    xWidth = sWidth;
  }
  var newWidth = find(Math.floor(xWidth / scaling));
  return newWidth ? isOSSImg ? "_".concat(newWidth, "w") : "".concat(newWidth, "x10000") : '';
}